<template>
  <div
    v-if="visible"
    @mouseenter="onMouseEnter()"
    @mouseleave="onMouseLeave()"
    class="ds-snackbar"
  >
    <div class="ds-snackbar__content">
      <div :class="`ds-snackbar__status ds-snackbar__status--${type}`">
        <DsIcon :name="type" size="small" />
      </div>

      <div class="ds-snackbar__text">
        {{ textFormatted }}
      </div>

      <div class="ds-snackbar__close" @click="closeClicked">
        <DsIcon name="close" size="small" />
      </div>
    </div>

    <div v-if="buttonLabel" class="ds-snackbar__button" @click="buttonClicked">
      {{ buttonLabel }}
    </div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Vue from 'vue';
import { DsIcon } from '@ds/icons';

const MAX_TEXT_LENGTH = 88;

export default Vue.extend({
  name: 'DsSnackbar',
  components: {
    DsIcon
  },
  data() {
    return {
      visible: this.show,
      maxLength: this.customMaxLength || MAX_TEXT_LENGTH,
      timeoutFunction: ''
    };
  },
  props: {
    /**
     * controls show or not the snackbar
     */
    show: {
      type: Boolean
    },
    /**
     * the text that will be shown to user
     */
    text: {
      type: String,
      required: true
    },
    /**
     * the label for the single snackbar button
     */
    buttonLabel: {
      type: String,
      default: ''
    },
    /**
     * custom max length
     */
    customMaxLength: {
      type: Number
    },

    /**
     * the type message of snack bar
     */
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['success', 'warning', 'info', 'error'].indexOf(value) !== -1;
      }
    },
    /**
     * the time that snackbar will be visible without user interaction
     */
    timeout: {
      type: Number,
      default: 6000
    },

    /**
     * prevent snackbar disappear when mouse is on snackbar
     */
    clearTimeoutOnMouseEnter: {
      type: Boolean
    },
    /**
     * controls the component color between light and dark theme
     */
    dark: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.timeoutFunction = setTimeout(() => this.closeClicked(), this.timeout);
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  },
  computed: {
    textFormatted() {
      if (this.text.length > this.maxLength) {
        return `${this.text}`.slice(0, this.maxLength);
      }

      return this.text;
    }
  },
  methods: {
    closeClicked() {
      this.visible = false;
      /**
       * event emitted when clicking on close
       */
      this.$emit('close');
    },
    buttonClicked() {
      this.visible = false;
      /**
       * event emitted when clicking on button
       */
      this.$emit('buttonClicked');
    },

    onMouseLeave() {
      if (this.clearTimeoutOnMouseEnter) {
        this.closeClicked();
      }
    },

    onMouseEnter() {
      if (this.clearTimeoutOnMouseEnter) {
        this.cancelTimeout();
      }
    },

    cancelTimeout() {
      clearTimeout(this.timeoutFunction);
    }
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Snackbar.scss';
</style>
